export const MFA_ERROR_MESSAGE = 'MFA email confirmation required'
